import { useBotDeliveryQuery as e, useBotsQuery as t, useCreateBotMutation as n, useDeleteBotMutation as r, useRenameBotMutation as i, useReplaceBotCredentialsMutation as a, useRequiredCredentialsQuery as o, useVerifyBotMutation as s } from "@frontends/data-access-spg-bots";
import { useAllInstancesQuery as c } from "@frontends/data-access-spg-instances";
import { useDataTable as l } from "@frontends/data-table";
import { DsAlert as u, DsBadge as d, DsButton as f, DsDialog as p, DsIconButton as m, DsLink as h, DsRadio as g, DsRadioGroup as _, dsToast as v } from "@frontends/ds";
import { Page as y, PageHeader as b, PropertyList as x } from "@frontends/ui-spg-layout";
import { useState as S } from "react";
import { useTranslation as C } from "react-i18next";
import { useSearchParams as w } from "react-router";
import { jsx as T, jsxs as E } from "react/jsx-runtime";
import { getApiErrorMessage as D } from "@frontends/util-api-errors";
import { formatDateTime as O } from "@frontends/util-spg-format";
import { useForm as k } from "@frontends/form";
import { UiKitAlertDialog as A } from "@frontends/ui-kit";
//#region src/lib/constants.ts
var j = "feature-spg-bots", M = [
	"telegram",
	"whatsapp",
	"discord"
];
//#endregion
//#region src/lib/components/BotAccount.tsx
function N({ bot: e }) {
	let { t } = C(j), n = e.username && `@${e.username}`, r = t(e.platform === "discord" ? "account.discordId" : "account.telegramId", { id: e.externalId });
	return /* @__PURE__ */ E("div", {
		className: "flex min-w-0 flex-col",
		children: [n && (e.platform === "telegram" ? /* @__PURE__ */ T(h, {
			href: `https://t.me/${e.username}`,
			target: "_blank",
			rel: "noreferrer",
			variant: "secondary",
			"aria-label": t("account.open", { username: e.username }),
			className: "self-start truncate",
			children: n
		}) : /* @__PURE__ */ T("span", {
			className: "truncate text-textPrimary",
			children: n
		})), /* @__PURE__ */ T("span", {
			className: "truncate font-mono text-sm text-textSecondary",
			children: r
		})]
	});
}
//#endregion
//#region src/lib/components/BotActions.tsx
var P = "text-textTertiary hover:text-textPrimary focus-visible:text-textPrimary", F = "text-textTertiary hover:text-textDangerPrimary focus-visible:text-textDangerPrimary";
function I({ botName: e, canCheckDelivery: t, onAction: n }) {
	let { t: r } = C(j);
	return /* @__PURE__ */ E("div", {
		className: "flex justify-end gap-1",
		children: [
			t && /* @__PURE__ */ T(m, {
				name: "radar",
				size: "sm",
				className: P,
				"aria-label": r("actions.deliveryOf", { name: e }),
				tooltip: r("actions.delivery"),
				onPress: () => n("delivery")
			}),
			/* @__PURE__ */ T(m, {
				name: "pencil",
				size: "sm",
				className: P,
				"aria-label": r("actions.renameOf", { name: e }),
				tooltip: r("actions.rename"),
				onPress: () => n("rename")
			}),
			/* @__PURE__ */ T(m, {
				name: "key-round",
				size: "sm",
				className: P,
				"aria-label": r("actions.replaceCredentialsOf", { name: e }),
				tooltip: r("actions.replaceCredentials"),
				onPress: () => n("replaceCredentials")
			}),
			/* @__PURE__ */ T(m, {
				name: "trash-2",
				size: "sm",
				className: F,
				"aria-label": r("actions.deleteOf", { name: e }),
				tooltip: r("actions.delete"),
				onPress: () => n("delete")
			})
		]
	});
}
//#endregion
//#region src/lib/components/BotDeliveryDialog.tsx
function L({ bot: t, onClose: n }) {
	let { t: r } = C(j), i = e(t.id);
	return /* @__PURE__ */ E(p, {
		title: r("delivery.title", { name: t.name }),
		size: "lg",
		isOpen: !0,
		onOpenChange: (e) => !e && n(),
		secondaryAction: {
			label: r("delivery.recheck"),
			isPending: i.isFetching,
			onPress: () => void i.refetch()
		},
		children: [
			i.isPending && /* @__PURE__ */ T("p", {
				className: "text-base text-textSecondary",
				children: r("delivery.loading")
			}),
			i.isError && /* @__PURE__ */ T(u, {
				variant: "danger",
				title: r("delivery.failed"),
				description: D(i.error, r("delivery.failedFallback"))
			}),
			i.data && /* @__PURE__ */ T(R, { delivery: i.data })
		]
	});
}
function R({ delivery: e }) {
	let { t } = C(j);
	return /* @__PURE__ */ E("div", {
		className: "flex flex-col gap-4",
		children: [
			!e.registered && /* @__PURE__ */ T(u, {
				variant: "danger",
				description: t("delivery.notRegisteredHint")
			}),
			e.registered && e.pendingUpdates > 0 && e.lastError && /* @__PURE__ */ T(u, {
				variant: "warning",
				description: t("delivery.backlogHint")
			}),
			/* @__PURE__ */ T(x, { items: [
				{
					label: t("delivery.fields.status"),
					value: /* @__PURE__ */ T(d, {
						size: "sm",
						variant: e.registered ? "success" : "danger",
						children: t(e.registered ? "delivery.registered" : "delivery.notRegistered")
					})
				},
				{
					label: t("delivery.fields.url"),
					value: /* @__PURE__ */ T("span", {
						className: "font-mono break-all",
						children: e.url || t("delivery.noUrl")
					})
				},
				{
					label: t("delivery.fields.pending"),
					value: e.pendingUpdates
				},
				{
					label: t("delivery.fields.lastError"),
					value: e.lastError ? t("delivery.errorAt", {
						error: e.lastError,
						at: O(e.lastErrorAt)
					}) : t("delivery.noError")
				}
			] })
		]
	});
}
//#endregion
//#region src/lib/components/CredentialsForm.tsx
function z({ kinds: e, submitLabel: t, onSubmit: n }) {
	let { t: r } = C(j);
	return /* @__PURE__ */ T(k({
		fields: Object.fromEntries(e.map((e) => [e, {
			type: "password",
			label: r(`credentials.${e}`),
			validators: ["required"]
		}])),
		submitLabel: t,
		onSubmit: (t) => n(Object.fromEntries(e.map((e) => [e, String(t[e]).trim()])))
	}).Form, { className: "flex flex-col gap-4" });
}
//#endregion
//#region src/lib/components/CreateBotDialog/components/CredentialsStep.tsx
function B({ onVerified: e }) {
	let { t } = C(j), [n, r] = S("telegram"), i = o(n), a = s();
	return /* @__PURE__ */ E("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ T(_, {
				label: t("create.platform"),
				orientation: "horizontal",
				value: n,
				onChange: (e) => r(e),
				children: M.map((e) => /* @__PURE__ */ T(g, {
					value: e,
					children: t(`platforms.${e}`)
				}, e))
			}),
			/* @__PURE__ */ T("p", {
				className: "text-base text-textSecondary",
				children: t(`create.hints.${n}`)
			}),
			i.isError && /* @__PURE__ */ T(u, {
				variant: "danger",
				description: i.error.detail
			}),
			i.isSuccess && /* @__PURE__ */ T(z, {
				kinds: i.data,
				submitLabel: t("create.verify"),
				onSubmit: async (t) => {
					let r = {
						platform: n,
						credentials: t
					};
					e({
						draft: r,
						identity: await a.mutateAsync(r)
					});
				}
			}, n)
		]
	});
}
//#endregion
//#region src/lib/components/CreateBotDialog/components/IdentityStep.tsx
function V({ verified: e, onBack: t, onCreated: r }) {
	let { t: i } = C(j), a = n(), { identity: o, draft: s } = e, c = k({
		fields: { name: {
			type: "text",
			label: i("create.name"),
			defaultValue: o.name,
			validators: ["required"]
		} },
		submitLabel: i("create.submit"),
		onSubmit: async (e) => {
			let t = await a.mutateAsync({
				...s,
				name: String(e.name).trim()
			});
			v.success({ title: i("create.created", { name: t.name }) }), r();
		}
	});
	return /* @__PURE__ */ E("div", {
		className: "flex flex-col gap-4",
		children: [
			/* @__PURE__ */ E("dl", {
				className: "grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-base",
				children: [
					/* @__PURE__ */ T("dt", {
						className: "text-textSecondary",
						children: i(`platforms.${s.platform}`)
					}),
					/* @__PURE__ */ T("dd", { children: o.username }),
					/* @__PURE__ */ T("dt", {
						className: "text-textSecondary",
						children: i("create.platformName")
					}),
					/* @__PURE__ */ T("dd", { children: o.name })
				]
			}),
			o.warnings.map((e) => /* @__PURE__ */ T(u, {
				variant: "warning",
				description: e
			}, e)),
			/* @__PURE__ */ T(c.Form, { className: "flex flex-col gap-4" }),
			/* @__PURE__ */ T(f, {
				variant: "quiet",
				onPress: t,
				children: i("create.back")
			})
		]
	});
}
//#endregion
//#region src/lib/components/CreateBotDialog/CreateBotDialog.tsx
function H({ isOpen: e, onOpenChange: t }) {
	let { t: n } = C(j), [r, i] = S(null), a = (e) => {
		e || i(null), t(e);
	};
	return /* @__PURE__ */ T(p, {
		title: n("create.title"),
		isOpen: e,
		onOpenChange: a,
		children: r === null ? /* @__PURE__ */ T(B, { onVerified: i }) : /* @__PURE__ */ T(V, {
			verified: r,
			onBack: () => i(null),
			onCreated: () => a(!1)
		})
	});
}
//#endregion
//#region src/lib/components/DeleteBotDialog.tsx
function U({ bot: e, onClose: t }) {
	let { t: n } = C(j), i = r(), a = async () => {
		try {
			await i.mutateAsync(e.id), v.success({ title: n("delete.done", { name: e.name }) });
		} catch (t) {
			v.danger({
				title: n("delete.failed", { name: e.name }),
				description: D(t, n("delete.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ T(A, {
		open: !0,
		onOpenChange: (e) => !e && t(),
		title: n("delete.title", { name: e.name }),
		description: n("delete.description"),
		confirmLabel: n("delete.confirm"),
		cancelLabel: n("delete.cancel"),
		onConfirm: () => void a()
	});
}
//#endregion
//#region src/lib/components/RenameBotDialog.tsx
function W({ bot: e, onClose: t }) {
	let { t: n } = C(j), r = i(), a = k({
		fields: { name: {
			type: "text",
			label: n("rename.name"),
			defaultValue: e.name,
			validators: ["required"]
		} },
		submitLabel: n("rename.submit"),
		onSubmit: async (i) => {
			let a = String(i.name).trim();
			await r.mutateAsync({
				id: e.id,
				name: a
			}), v.success({ title: n("rename.done", { name: a }) }), t();
		}
	});
	return /* @__PURE__ */ T(p, {
		title: n("rename.title"),
		isOpen: !0,
		onOpenChange: (e) => !e && t(),
		children: /* @__PURE__ */ T(a.Form, { className: "flex flex-col gap-4" })
	});
}
//#endregion
//#region src/lib/components/ReplaceCredentialsDialog.tsx
function G({ bot: e, onClose: t }) {
	let { t: n } = C(j), r = o(e.platform), i = a();
	return /* @__PURE__ */ T(p, {
		title: n("replaceCredentials.title", { name: e.name }),
		isOpen: !0,
		onOpenChange: (e) => !e && t(),
		children: /* @__PURE__ */ E("div", {
			className: "flex flex-col gap-4",
			children: [
				/* @__PURE__ */ T("p", {
					className: "text-base text-textSecondary",
					children: n("replaceCredentials.hint")
				}),
				r.isError && /* @__PURE__ */ T(u, {
					variant: "danger",
					description: r.error.detail
				}),
				r.isSuccess && /* @__PURE__ */ T(z, {
					kinds: r.data,
					submitLabel: n("replaceCredentials.submit"),
					onSubmit: async (r) => {
						await i.mutateAsync({
							id: e.id,
							credentials: r
						}), v.success({ title: n("replaceCredentials.done", { name: e.name }) }), t();
					}
				})
			]
		})
	});
}
//#endregion
//#region src/lib/pages/BotsPage.tsx
function K({ getInstanceHref: e }) {
	let { t: n } = C(j), r = w(), i = c().data ?? [], a = new Map(i.map((e) => [e.botId, e])), [o, s] = S(!1), [u, p] = S(null), m = () => p(null), g = [
		{
			id: "name",
			label: n("columns.name"),
			isRowHeader: !0,
			isSortable: !0,
			cell: (e) => e.name
		},
		{
			id: "account",
			label: n("columns.account"),
			width: 260,
			cell: (e) => /* @__PURE__ */ T(N, { bot: e })
		},
		{
			id: "platform",
			label: n("columns.platform"),
			isSortable: !0,
			width: 160,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ T(d, { children: n(`platforms.${e.platform}`) })
		},
		{
			id: "instance",
			label: n("columns.instance"),
			cell: (t) => {
				let r = a.get(t.id);
				return r ? /* @__PURE__ */ T(h, {
					href: e(r.id),
					children: r.name
				}) : /* @__PURE__ */ T("span", {
					className: "text-textTertiary",
					children: n("columns.noInstance")
				});
			}
		},
		{
			id: "actions",
			label: n("columns.actions"),
			align: "end",
			width: 150,
			cell: (e) => /* @__PURE__ */ T(I, {
				botName: e.name,
				canCheckDelivery: e.platform === "telegram",
				onAction: (t) => p({
					action: t,
					bot: e
				})
			})
		}
	], _ = l({
		"aria-label": n("table.label"),
		columns: g,
		defaultSort: {
			by: "name",
			order: "asc"
		},
		getRowKey: (e) => e.id,
		searchParams: r,
		filters: {
			platform: {
				type: "chips",
				label: n("filters.platform"),
				defaultValue: "all",
				options: [{
					value: "all",
					label: n("filters.allPlatforms")
				}, ...M.map((e) => ({
					value: e,
					label: n(`platforms.${e}`)
				}))]
			},
			query: {
				type: "search",
				label: n("filters.search"),
				defaultValue: ""
			}
		}
	}), v = t(_.requestParams, _.filters);
	return /* @__PURE__ */ E(y, { children: [
		/* @__PURE__ */ T(b, { title: n("title") }),
		/* @__PURE__ */ E(_.Frame, { children: [/* @__PURE__ */ T(_.Toolbar, { children: /* @__PURE__ */ T(f, {
			iconStart: "plus",
			onPress: () => s(!0),
			children: n("create.open")
		}) }), /* @__PURE__ */ T(_.Table, {
			query: v,
			emptyState: {
				icon: "bot",
				title: n("empty.title"),
				actionLabel: n("create.open"),
				onAction: () => s(!0)
			}
		})] }),
		/* @__PURE__ */ T(H, {
			isOpen: o,
			onOpenChange: s
		}),
		u?.action === "delivery" && /* @__PURE__ */ T(L, {
			bot: u.bot,
			onClose: m
		}),
		u?.action === "rename" && /* @__PURE__ */ T(W, {
			bot: u.bot,
			onClose: m
		}),
		u?.action === "replaceCredentials" && /* @__PURE__ */ T(G, {
			bot: u.bot,
			onClose: m
		}),
		u?.action === "delete" && /* @__PURE__ */ T(U, {
			bot: u.bot,
			onClose: m
		})
	] });
}
//#endregion
export { K as BotsPage, j as FEATURE_SPG_BOTS_NAMESPACE };
